/** Import react/libraries section **/
import React from 'react';

/** Import helpers section **/

/** Import resources section **/
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

/** Import syles section **/
import './DocumentModalStyles.scss';

/** Import component section **/
import ModalComponent from '../../../components/Modal';
import MUITextField from '../../../components/inputs/MUITextField';
import MUISelect from '../../../components/inputs/MUISelect';

const DocumentModalView = ({
  document,
  categories,
  validity,
  onInputChange,
  onSwitchChange,
  onClose,
  onSave,
  disabled
}) => {
  const title = document?.id
    ? 'Editar tipo de documento'
    : 'Agregar tipo de documento';
  return (
    <ModalComponent
      open={true}
      title={title}
      element={document}
      onClose={onClose}
      onConfirm={onSave}
      disabled={disabled}
    >
      <div className="documentModal">
        <FormControlLabel
          className="documentModal_active"
          control={
            <Switch
              label="Activo"
              checked={document?.active === 1}
              onChange={onSwitchChange}
              name="active"
              color="primary"
              inputProps={{
                'aria-label': 'secondary checkbox'
              }}
            />
          }
          label="Activo"
        />
        <MUITextField
          label="Documento"
          defaultValue={document?.name}
          type="text"
          id="name"
          name="name"
          onChange={onInputChange}
        />
        <MUISelect
          label="Categoría"
          defaultValue={document?.document_category_id}
          items={categories}
          idSelector="id"
          selector="name"
          noSelectedLabel="Select"
          name="document_category_id"
          onChange={onInputChange}
        />
        <MUITextField
          label="Descripción"
          defaultValue={document?.description}
          type="text"
          id="description"
          name="description"
          onChange={onInputChange}
        />
        <MUISelect
          label="Validez"
          defaultValue={document?.document_validity_id}
          items={validity}
          idSelector="id"
          selector="name"
          noSelectedLabel="Select"
          name="document_validity_id"
          onChange={onInputChange}
        />
      </div>
    </ModalComponent>
  );
};

export default DocumentModalView;
